module.exports = __webpack_public_path__ + "img/bison_router_logo.d1687d60.svg";